import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { JoykitColor } from '@components/themes';
import {
  WrapperProps,
  Alignment,
  Gap,
  Scale,
  StyledColumns,
  StyledColumn,
  StyledFlex,
  StyledText,
  StyledCTALink,
} from './CloudImageRow.styles';

interface CloudImageProps {
  sm: WrapperProps;
  belowSm: WrapperProps;
  link?: string;
  title?: string;
  image?: {
    url: string;
  };
  text?: {
    content: string;
    color: JoykitColor;
    backgroundColor: JoykitColor;
  };
  circle?: boolean;
}

interface Props {
  images: CloudImageRowProps;
  alignment?: Alignment;
  gap?: Gap;
  scale?: Scale;
  elementId?: string;
  imageScale?: Scale;
  isEagerLoading?: boolean;
}

export type ImageGap = Gap;

export type ImageScale = Scale;

export type CloudImageRowProps = CloudImageProps[];

export const CloudImageRow: React.FC<Props> = ({
  images,
  alignment = 'center',
  gap = { sm: 64, belowSm: 16 },
  scale = { xl: 1, lg: 1, sm: 0.8, belowSm: 1 },
  imageScale = { xl: 1, lg: 1, sm: 1, belowSm: 1 },
  elementId,
  isEagerLoading = false,
}) => {
  return (
    <StyledColumns stackOnMobile={false} centered verticalAlign="center" alignment={alignment} gap={gap} scale={scale}>
      {images.map((item, index) => (
        <StyledColumn width={3} key={index} imageScale={imageScale}>
          <StyledFlex
            backgroundColor={item.text ? item.text.backgroundColor : 'white'}
            alignItems="center"
            justifyContent="center"
            circle={item.circle?.toString()}
            sm={item.sm}
            belowsm={item.belowSm}
            padding={item.text ? 7 : 0}
          >
            {item.image && !item.link && (
              <CloudImage
                src={item.image.url}
                width="100%"
                height="100%"
                alt={item.title}
                optimization="default"
                isEagerLoading={isEagerLoading}
              />
            )}
            {item.image && item.link && (
              <StyledCTALink
                id={`infinite-slider-link-${index}`}
                href={item.link}
                target="_blank"
                aria-label={item.title}
                data-element-id={elementId}
              >
                <CloudImage
                  src={item.image.url}
                  width="100%"
                  height="100%"
                  alt={item.title}
                  optimization="default"
                  isEagerLoading={isEagerLoading}
                />
              </StyledCTALink>
            )}
            {item.text && (
              <StyledText tagName="p" variant="hed40" color={item.text.color}>
                {item.text.content}
              </StyledText>
            )}
          </StyledFlex>
        </StyledColumn>
      ))}
    </StyledColumns>
  );
};
